module.exports = __webpack_public_path__ + "i18n/ja.json";


/*****************
 ** WEBPACK FOOTER
 ** ./~/file-loader?name=i18n/[name].[ext]!./i18n/ja.json
 ** module id = 802
 ** module chunks = 0
 **/